import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from '@nerdwallet/base-styles/classes';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { Heading, Text } from '@nerdwallet/react-typography';
import Image from '@nerdwallet/react-image';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';

const Security = ({ imageSrc, securityHeader, securityText }) => (
  <BedrockImpression entityName="acct_security_container">
    <ElementImpression
      elementDomType="section"
      elementName="Security"
      id="security-container"
    >
      <section
        className={classNames([
          'security__section',
          classes('margin-horizontal-3'),
          classes('margin-bottom-5'),
          classes('margin-horizontal-auto--wide'),
          classes('padding-horizontal-4--wide'),
        ])}
      >
        <div
          className={classNames([
            'security__content',
            classes('padding-vertical-4'),
            classes('padding-horizontal-0'),
            classes('padding-horizontal-4--wide'),
            classes('display-flex'),
            classes('flex-direction-column'),
            classes('flex-direction-row--wide'),
          ])}
        >
          <div>
            <div
              className={classNames([
                'security__image-cont',
                classes('margin-right-5--wide'),
                classes('margin-left-4--wide'),
                classes('padding-horizontal-3--wide'),
              ])}
            >
              <Image
                src={imageSrc}
                alt=""
                naturalWidth={50}
                naturalHeight={71}
                backgroundColor="transparent"
                imageClassName={classNames([
                  'security__image',
                  classes('margin-top-2--wide'),
                  classes('margin-bottom-3'),
                  classes('margin-vertical-0'),
                  classes('align-items-center--wide'),
                ])}
              />
            </div>
          </div>
          <div
            className={classNames([
              'security__content-inner',
              classes('display-flex--wide'),
              classes('flex-direction-column--wide'),
            ])}
          >
            <Heading
              level={2}
              chronicle
              className={classNames([
                'security-section__header',
                classes('text-align-left--wide'),
                classes('padding-bottom-3'),
              ])}
            >
              {securityHeader}
            </Heading>
            <Text
              className={classNames([
                'security-section__text',
                classes('text-align-left--wide'),
              ])}
            >
              {securityText}
            </Text>
          </div>
        </div>
      </section>
    </ElementImpression>
  </BedrockImpression>
);

Security.propTypes = {
  imageSrc: PropTypes.string,
  securityHeader: PropTypes.string,
  securityText: PropTypes.node,
};

Security.displayName = 'Security';

export default Security;
